import MyArea from './myArea.vue';

MyArea.install = function(Vue){
  Vue.component('MyArea', MyArea);
};

export default MyArea;